"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_common.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeProductListingApplicationListItem = exports.EMSOrdermadeProductColorSurfaceImage = exports.EMSOrdermadeProductListingApplicationDetail = exports.EMSOrdermadeProductListItem = exports.EMSOrdermadeProduct = exports.EMSOrdermadeTalent = exports.EMSOrdermadeProductTag = exports.EMSOrdermadeProductCollection = exports.EMSOrdermadeProductDesignSurface = exports.EMSOrdermadeProductDesign = exports.EMSOrdermadeProductVariant = exports.EMSOrdermadeProductVariantOptionValue = exports.EMSOrdermadeProductOptionValue = exports.EMSOrdermadeProductOption = exports.EMSOrdermadeBrandImage = exports.EMSOrdermadeProductListingApplicationStatus = exports.EMSOrdermadeInventoryLevel = exports.EMSOrdermadeImageFileExtension = exports.EMSOrdermadeProductStatus = exports.EMSOrdermadeProductSalesStatus = exports.EMSOrdermadeProductListingReviewStatus = exports.EMSOrdermadeProductPublishStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * 公開ステータス
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductPublishStatus
 */
var EMSOrdermadeProductPublishStatus;
(function (EMSOrdermadeProductPublishStatus) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductPublishStatus[EMSOrdermadeProductPublishStatus["EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_DRAFT = 1;
     */
    EMSOrdermadeProductPublishStatus[EMSOrdermadeProductPublishStatus["EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_DRAFT"] = 1] = "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_DRAFT";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNPUBLISHED = 2;
     */
    EMSOrdermadeProductPublishStatus[EMSOrdermadeProductPublishStatus["EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNPUBLISHED"] = 2] = "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNPUBLISHED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_PUBLISHED = 3;
     */
    EMSOrdermadeProductPublishStatus[EMSOrdermadeProductPublishStatus["EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_PUBLISHED"] = 3] = "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_PUBLISHED";
})(EMSOrdermadeProductPublishStatus || (exports.EMSOrdermadeProductPublishStatus = EMSOrdermadeProductPublishStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductPublishStatus)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductPublishStatus, "spwn.ordermade.v1.EMSOrdermadeProductPublishStatus", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_DRAFT" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNPUBLISHED" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_PUBLISHED" },
]);
/**
 * 販売申請ステータス
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductListingReviewStatus
 */
var EMSOrdermadeProductListingReviewStatus;
(function (EMSOrdermadeProductListingReviewStatus) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductListingReviewStatus[EMSOrdermadeProductListingReviewStatus["EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSUBMITTED = 1;
     */
    EMSOrdermadeProductListingReviewStatus[EMSOrdermadeProductListingReviewStatus["EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSUBMITTED"] = 1] = "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSUBMITTED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_SUBMITTED = 2;
     */
    EMSOrdermadeProductListingReviewStatus[EMSOrdermadeProductListingReviewStatus["EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_SUBMITTED"] = 2] = "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_SUBMITTED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_REJECTED = 3;
     */
    EMSOrdermadeProductListingReviewStatus[EMSOrdermadeProductListingReviewStatus["EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_REJECTED"] = 3] = "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_REJECTED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_APPROVED = 4;
     */
    EMSOrdermadeProductListingReviewStatus[EMSOrdermadeProductListingReviewStatus["EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_APPROVED"] = 4] = "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_APPROVED";
})(EMSOrdermadeProductListingReviewStatus || (exports.EMSOrdermadeProductListingReviewStatus = EMSOrdermadeProductListingReviewStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductListingReviewStatus)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductListingReviewStatus, "spwn.ordermade.v1.EMSOrdermadeProductListingReviewStatus", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSUBMITTED" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_SUBMITTED" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_REJECTED" },
    { no: 4, name: "EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_APPROVED" },
]);
/**
 * 販売ステータス
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductSalesStatus
 */
var EMSOrdermadeProductSalesStatus;
(function (EMSOrdermadeProductSalesStatus) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductSalesStatus[EMSOrdermadeProductSalesStatus["EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_SALES_STATUS_BEFORE_SALE = 1;
     */
    EMSOrdermadeProductSalesStatus[EMSOrdermadeProductSalesStatus["EMS_ORDERMADE_PRODUCT_SALES_STATUS_BEFORE_SALE"] = 1] = "EMS_ORDERMADE_PRODUCT_SALES_STATUS_BEFORE_SALE";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_SALES_STATUS_ON_SALE = 2;
     */
    EMSOrdermadeProductSalesStatus[EMSOrdermadeProductSalesStatus["EMS_ORDERMADE_PRODUCT_SALES_STATUS_ON_SALE"] = 2] = "EMS_ORDERMADE_PRODUCT_SALES_STATUS_ON_SALE";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_SALES_STATUS_ENDED = 3;
     */
    EMSOrdermadeProductSalesStatus[EMSOrdermadeProductSalesStatus["EMS_ORDERMADE_PRODUCT_SALES_STATUS_ENDED"] = 3] = "EMS_ORDERMADE_PRODUCT_SALES_STATUS_ENDED";
})(EMSOrdermadeProductSalesStatus || (exports.EMSOrdermadeProductSalesStatus = EMSOrdermadeProductSalesStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductSalesStatus)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductSalesStatus, "spwn.ordermade.v1.EMSOrdermadeProductSalesStatus", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_SALES_STATUS_BEFORE_SALE" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_SALES_STATUS_ON_SALE" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_SALES_STATUS_ENDED" },
]);
/**
 * 商品ステータス (publish_status / listing_review_status / sales_*_at から派生する統合ステータス)
 * 仕様: https://www.notion.so/balusco/91298eee078b825ca400817790e66505
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductStatus
 */
var EMSOrdermadeProductStatus;
(function (EMSOrdermadeProductStatus) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED";
    /**
     * 下書き (未申請)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_DRAFT = 1;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_DRAFT"] = 1] = "EMS_ORDERMADE_PRODUCT_STATUS_DRAFT";
    /**
     * 申請中
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_PENDING_APPROVAL = 2;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_PENDING_APPROVAL"] = 2] = "EMS_ORDERMADE_PRODUCT_STATUS_PENDING_APPROVAL";
    /**
     * 却下
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_REJECTED = 3;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_REJECTED"] = 3] = "EMS_ORDERMADE_PRODUCT_STATUS_REJECTED";
    /**
     * 承認済み (公開・販売予約未設定)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_APPROVED = 4;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_APPROVED"] = 4] = "EMS_ORDERMADE_PRODUCT_STATUS_APPROVED";
    /**
     * 販売前 (公開予約 or 販売開始日時が未来)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_SCHEDULED_PUBLIC = 5;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_SCHEDULED_PUBLIC"] = 5] = "EMS_ORDERMADE_PRODUCT_STATUS_SCHEDULED_PUBLIC";
    /**
     * 販売中
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_SELLING = 6;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_SELLING"] = 6] = "EMS_ORDERMADE_PRODUCT_STATUS_SELLING";
    /**
     * 販売終了
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_STATUS_ENDED = 7;
     */
    EMSOrdermadeProductStatus[EMSOrdermadeProductStatus["EMS_ORDERMADE_PRODUCT_STATUS_ENDED"] = 7] = "EMS_ORDERMADE_PRODUCT_STATUS_ENDED";
})(EMSOrdermadeProductStatus || (exports.EMSOrdermadeProductStatus = EMSOrdermadeProductStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductStatus)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductStatus, "spwn.ordermade.v1.EMSOrdermadeProductStatus", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_STATUS_DRAFT" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_STATUS_PENDING_APPROVAL" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_STATUS_REJECTED" },
    { no: 4, name: "EMS_ORDERMADE_PRODUCT_STATUS_APPROVED" },
    { no: 5, name: "EMS_ORDERMADE_PRODUCT_STATUS_SCHEDULED_PUBLIC" },
    { no: 6, name: "EMS_ORDERMADE_PRODUCT_STATUS_SELLING" },
    { no: 7, name: "EMS_ORDERMADE_PRODUCT_STATUS_ENDED" },
]);
/**
 * 画像ファイル拡張子
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeImageFileExtension
 */
var EMSOrdermadeImageFileExtension;
(function (EMSOrdermadeImageFileExtension) {
    /**
     * @generated from enum value: EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED = 0;
     */
    EMSOrdermadeImageFileExtension[EMSOrdermadeImageFileExtension["EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_IMAGE_FILE_EXTENSION_PNG = 1;
     */
    EMSOrdermadeImageFileExtension[EMSOrdermadeImageFileExtension["EMS_ORDERMADE_IMAGE_FILE_EXTENSION_PNG"] = 1] = "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_PNG";
    /**
     * @generated from enum value: EMS_ORDERMADE_IMAGE_FILE_EXTENSION_JPEG = 2;
     */
    EMSOrdermadeImageFileExtension[EMSOrdermadeImageFileExtension["EMS_ORDERMADE_IMAGE_FILE_EXTENSION_JPEG"] = 2] = "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_JPEG";
})(EMSOrdermadeImageFileExtension || (exports.EMSOrdermadeImageFileExtension = EMSOrdermadeImageFileExtension = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeImageFileExtension)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeImageFileExtension, "spwn.ordermade.v1.EMSOrdermadeImageFileExtension", [
    { no: 0, name: "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_PNG" },
    { no: 2, name: "EMS_ORDERMADE_IMAGE_FILE_EXTENSION_JPEG" },
]);
/**
 * 在庫レベル(◯/△/✗の3段階)
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeInventoryLevel
 */
var EMSOrdermadeInventoryLevel;
(function (EMSOrdermadeInventoryLevel) {
    /**
     * @generated from enum value: EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED = 0;
     */
    EMSOrdermadeInventoryLevel[EMSOrdermadeInventoryLevel["EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED";
    /**
     * ◯ 在庫あり(余裕)
     *
     * @generated from enum value: EMS_ORDERMADE_INVENTORY_LEVEL_IN_STOCK = 1;
     */
    EMSOrdermadeInventoryLevel[EMSOrdermadeInventoryLevel["EMS_ORDERMADE_INVENTORY_LEVEL_IN_STOCK"] = 1] = "EMS_ORDERMADE_INVENTORY_LEVEL_IN_STOCK";
    /**
     * △ 残り少ない
     *
     * @generated from enum value: EMS_ORDERMADE_INVENTORY_LEVEL_LOW_STOCK = 2;
     */
    EMSOrdermadeInventoryLevel[EMSOrdermadeInventoryLevel["EMS_ORDERMADE_INVENTORY_LEVEL_LOW_STOCK"] = 2] = "EMS_ORDERMADE_INVENTORY_LEVEL_LOW_STOCK";
    /**
     * ✗ 在庫なし
     *
     * @generated from enum value: EMS_ORDERMADE_INVENTORY_LEVEL_OUT_OF_STOCK = 3;
     */
    EMSOrdermadeInventoryLevel[EMSOrdermadeInventoryLevel["EMS_ORDERMADE_INVENTORY_LEVEL_OUT_OF_STOCK"] = 3] = "EMS_ORDERMADE_INVENTORY_LEVEL_OUT_OF_STOCK";
})(EMSOrdermadeInventoryLevel || (exports.EMSOrdermadeInventoryLevel = EMSOrdermadeInventoryLevel = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeInventoryLevel)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeInventoryLevel, "spwn.ordermade.v1.EMSOrdermadeInventoryLevel", [
    { no: 0, name: "EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_INVENTORY_LEVEL_IN_STOCK" },
    { no: 2, name: "EMS_ORDERMADE_INVENTORY_LEVEL_LOW_STOCK" },
    { no: 3, name: "EMS_ORDERMADE_INVENTORY_LEVEL_OUT_OF_STOCK" },
]);
/**
 * OM商品販売申請ステータス
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductListingApplicationStatus
 */
var EMSOrdermadeProductListingApplicationStatus;
(function (EMSOrdermadeProductListingApplicationStatus) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductListingApplicationStatus[EMSOrdermadeProductListingApplicationStatus["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_SUBMITTED = 1;
     */
    EMSOrdermadeProductListingApplicationStatus[EMSOrdermadeProductListingApplicationStatus["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_SUBMITTED"] = 1] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_SUBMITTED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_APPROVED = 2;
     */
    EMSOrdermadeProductListingApplicationStatus[EMSOrdermadeProductListingApplicationStatus["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_APPROVED"] = 2] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_APPROVED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_REJECTED = 3;
     */
    EMSOrdermadeProductListingApplicationStatus[EMSOrdermadeProductListingApplicationStatus["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_REJECTED"] = 3] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_REJECTED";
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_WITHDRAWN = 4;
     */
    EMSOrdermadeProductListingApplicationStatus[EMSOrdermadeProductListingApplicationStatus["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_WITHDRAWN"] = 4] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_WITHDRAWN";
})(EMSOrdermadeProductListingApplicationStatus || (exports.EMSOrdermadeProductListingApplicationStatus = EMSOrdermadeProductListingApplicationStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductListingApplicationStatus)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductListingApplicationStatus, "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationStatus", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_SUBMITTED" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_APPROVED" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_REJECTED" },
    { no: 4, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_WITHDRAWN" },
]);
/**
 * ブランド画像
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeBrandImage
 */
class EMSOrdermadeBrandImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeBrandImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeBrandImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeBrandImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeBrandImage, a, b);
    }
}
exports.EMSOrdermadeBrandImage = EMSOrdermadeBrandImage;
EMSOrdermadeBrandImage.runtime = protobuf_1.proto3;
EMSOrdermadeBrandImage.typeName = "spwn.ordermade.v1.EMSOrdermadeBrandImage";
EMSOrdermadeBrandImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 商品オプション
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductOption
 */
class EMSOrdermadeProductOption extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductOptionValue values = 3;
         */
        this.values = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductOption, a, b);
    }
}
exports.EMSOrdermadeProductOption = EMSOrdermadeProductOption;
EMSOrdermadeProductOption.runtime = protobuf_1.proto3;
EMSOrdermadeProductOption.typeName = "spwn.ordermade.v1.EMSOrdermadeProductOption";
EMSOrdermadeProductOption.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "values", kind: "message", T: EMSOrdermadeProductOptionValue, repeated: true },
]);
/**
 * 商品オプション値
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductOptionValue
 */
class EMSOrdermadeProductOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductOptionValue, a, b);
    }
}
exports.EMSOrdermadeProductOptionValue = EMSOrdermadeProductOptionValue;
EMSOrdermadeProductOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeProductOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeProductOptionValue";
EMSOrdermadeProductOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * バリアントのオプション値(バリアントを構成するオプションの1つ)
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductVariantOptionValue
 */
class EMSOrdermadeProductVariantOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_option_value_id = 1;
         */
        this.omProductOptionValueId = "";
        /**
         * 例: "ホワイト"
         *
         * @generated from field: string om_product_option_value_name = 2;
         */
        this.omProductOptionValueName = "";
        /**
         * @generated from field: string om_product_option_id = 3;
         */
        this.omProductOptionId = "";
        /**
         * 例: "カラー"
         *
         * @generated from field: string om_product_option_name = 4;
         */
        this.omProductOptionName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductVariantOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductVariantOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductVariantOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductVariantOptionValue, a, b);
    }
}
exports.EMSOrdermadeProductVariantOptionValue = EMSOrdermadeProductVariantOptionValue;
EMSOrdermadeProductVariantOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeProductVariantOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeProductVariantOptionValue";
EMSOrdermadeProductVariantOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_option_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "om_product_option_value_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "om_product_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "om_product_option_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 商品バリアント (バリアント名はoption_valuesを組み合わせた値)
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductVariant
 */
class EMSOrdermadeProductVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: int32 price = 2;
         */
        this.price = 0;
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductVariantOptionValue option_values = 5;
         */
        this.optionValues = [];
        /**
         * 在庫レベル
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeInventoryLevel inventory_level = 6;
         */
        this.inventoryLevel = EMSOrdermadeInventoryLevel.EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED;
        /**
         * 販売中に設定しているか
         *
         * @generated from field: bool is_on_sale = 7;
         */
        this.isOnSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductVariant, a, b);
    }
}
exports.EMSOrdermadeProductVariant = EMSOrdermadeProductVariant;
EMSOrdermadeProductVariant.runtime = protobuf_1.proto3;
EMSOrdermadeProductVariant.typeName = "spwn.ordermade.v1.EMSOrdermadeProductVariant";
EMSOrdermadeProductVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "image", kind: "message", T: EMSOrdermadeBrandImage, opt: true },
    { no: 4, name: "sales_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "option_values", kind: "message", T: EMSOrdermadeProductVariantOptionValue, repeated: true },
    { no: 6, name: "inventory_level", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeInventoryLevel) },
    { no: 7, name: "is_on_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * 商品デザイン
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductDesign
 */
class EMSOrdermadeProductDesign extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 工場商品マスタID
         *
         * @generated from field: string factory_base_item_id = 1;
         */
        this.factoryBaseItemId = "";
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductDesignSurface surfaces = 2;
         */
        this.surfaces = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductDesign().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductDesign().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductDesign().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductDesign, a, b);
    }
}
exports.EMSOrdermadeProductDesign = EMSOrdermadeProductDesign;
EMSOrdermadeProductDesign.runtime = protobuf_1.proto3;
EMSOrdermadeProductDesign.typeName = "spwn.ordermade.v1.EMSOrdermadeProductDesign";
EMSOrdermadeProductDesign.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "factory_base_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "surfaces", kind: "message", T: EMSOrdermadeProductDesignSurface, repeated: true },
]);
/**
 * 面ごとのデザイン
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductDesignSurface
 */
class EMSOrdermadeProductDesignSurface extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 印刷面ID(om_factory_print_surface.surface_codeの値)
         *
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * konvaが生成したデザインスペック(JSON string)
         *
         * @generated from field: string konva_design_spec = 2;
         */
        this.konvaDesignSpec = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductDesignSurface().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductDesignSurface().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductDesignSurface().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductDesignSurface, a, b);
    }
}
exports.EMSOrdermadeProductDesignSurface = EMSOrdermadeProductDesignSurface;
EMSOrdermadeProductDesignSurface.runtime = protobuf_1.proto3;
EMSOrdermadeProductDesignSurface.typeName = "spwn.ordermade.v1.EMSOrdermadeProductDesignSurface";
EMSOrdermadeProductDesignSurface.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "konva_design_spec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * コレクション
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductCollection
 */
class EMSOrdermadeProductCollection extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string shopify_collection_id = 1;
         */
        this.shopifyCollectionId = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductCollection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductCollection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductCollection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductCollection, a, b);
    }
}
exports.EMSOrdermadeProductCollection = EMSOrdermadeProductCollection;
EMSOrdermadeProductCollection.runtime = protobuf_1.proto3;
EMSOrdermadeProductCollection.typeName = "spwn.ordermade.v1.EMSOrdermadeProductCollection";
EMSOrdermadeProductCollection.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shopify_collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * タグ
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductTag
 */
class EMSOrdermadeProductTag extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductTag().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductTag().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductTag().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductTag, a, b);
    }
}
exports.EMSOrdermadeProductTag = EMSOrdermadeProductTag;
EMSOrdermadeProductTag.runtime = protobuf_1.proto3;
EMSOrdermadeProductTag.typeName = "spwn.ordermade.v1.EMSOrdermadeProductTag";
EMSOrdermadeProductTag.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * タレント (商品紐付け表示用)。yoshimoto_profile_id は外部システム由来のID
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeTalent
 */
class EMSOrdermadeTalent extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 yoshimoto_profile_id = 1;
         */
        this.yoshimotoProfileId = 0;
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeTalent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeTalent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeTalent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeTalent, a, b);
    }
}
exports.EMSOrdermadeTalent = EMSOrdermadeTalent;
EMSOrdermadeTalent.runtime = protobuf_1.proto3;
EMSOrdermadeTalent.typeName = "spwn.ordermade.v1.EMSOrdermadeTalent";
EMSOrdermadeTalent.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "yoshimoto_profile_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 商品詳細
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProduct
 */
class EMSOrdermadeProduct extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductPublishStatus publish_status = 3;
         */
        this.publishStatus = EMSOrdermadeProductPublishStatus.EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED;
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductListingReviewStatus listing_review_status = 4;
         */
        this.listingReviewStatus = EMSOrdermadeProductListingReviewStatus.EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED;
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductSalesStatus sales_status = 5;
         */
        this.salesStatus = EMSOrdermadeProductSalesStatus.EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeBrandImage images = 6;
         */
        this.images = [];
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductOption options = 7;
         */
        this.options = [];
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductVariant variants = 8;
         */
        this.variants = [];
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductCollection collections = 10;
         */
        this.collections = [];
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductTag tags = 11;
         */
        this.tags = [];
        /**
         * 統合ステータス (派生値、編集可否判定等に使う)
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductStatus status = 18;
         */
        this.status = EMSOrdermadeProductStatus.EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED;
        /**
         * 紐付けタレント (priority 昇順)
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeTalent talents = 20;
         */
        this.talents = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProduct, a, b);
    }
}
exports.EMSOrdermadeProduct = EMSOrdermadeProduct;
EMSOrdermadeProduct.runtime = protobuf_1.proto3;
EMSOrdermadeProduct.typeName = "spwn.ordermade.v1.EMSOrdermadeProduct";
EMSOrdermadeProduct.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductPublishStatus) },
    { no: 4, name: "listing_review_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductListingReviewStatus) },
    { no: 5, name: "sales_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductSalesStatus) },
    { no: 6, name: "images", kind: "message", T: EMSOrdermadeBrandImage, repeated: true },
    { no: 7, name: "options", kind: "message", T: EMSOrdermadeProductOption, repeated: true },
    { no: 8, name: "variants", kind: "message", T: EMSOrdermadeProductVariant, repeated: true },
    { no: 9, name: "description_as_tiptap", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "collections", kind: "message", T: EMSOrdermadeProductCollection, repeated: true },
    { no: 11, name: "tags", kind: "message", T: EMSOrdermadeProductTag, repeated: true },
    { no: 12, name: "scheduled_publish_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
    { no: 13, name: "sales_start_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
    { no: 14, name: "sales_end_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
    { no: 15, name: "created_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 16, name: "updated_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 17, name: "design", kind: "message", T: EMSOrdermadeProductDesign },
    { no: 18, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductStatus) },
    { no: 19, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "talents", kind: "message", T: EMSOrdermadeTalent, repeated: true },
]);
/**
 * 商品一覧アイテム
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductListItem
 */
class EMSOrdermadeProductListItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * 販売ステータス
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductSalesStatus sales_status = 5;
         */
        this.salesStatus = EMSOrdermadeProductSalesStatus.EMS_ORDERMADE_PRODUCT_SALES_STATUS_UNSPECIFIED;
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductPublishStatus publish_status = 6;
         */
        this.publishStatus = EMSOrdermadeProductPublishStatus.EMS_ORDERMADE_PRODUCT_PUBLISH_STATUS_UNSPECIFIED;
        /**
         * 販売申請ステータス
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductListingReviewStatus listing_review_status = 7;
         */
        this.listingReviewStatus = EMSOrdermadeProductListingReviewStatus.EMS_ORDERMADE_PRODUCT_LISTING_REVIEW_STATUS_UNSPECIFIED;
        /**
         * 統合ステータス (派生値)
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductStatus status = 8;
         */
        this.status = EMSOrdermadeProductStatus.EMS_ORDERMADE_PRODUCT_STATUS_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductListItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductListItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductListItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductListItem, a, b);
    }
}
exports.EMSOrdermadeProductListItem = EMSOrdermadeProductListItem;
EMSOrdermadeProductListItem.runtime = protobuf_1.proto3;
EMSOrdermadeProductListItem.typeName = "spwn.ordermade.v1.EMSOrdermadeProductListItem";
EMSOrdermadeProductListItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_image", kind: "message", T: EMSOrdermadeBrandImage, opt: true },
    { no: 4, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "sales_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductSalesStatus) },
    { no: 6, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductPublishStatus) },
    { no: 7, name: "listing_review_status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductListingReviewStatus) },
    { no: 8, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductStatus) },
]);
/**
 * OM商品販売申請詳細
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductListingApplicationDetail
 */
class EMSOrdermadeProductListingApplicationDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Review API(承認/却下)で対象を指定する際に使用
         *
         * @generated from field: string om_product_id = 2;
         */
        this.omProductId = "";
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeProductListingApplicationStatus status = 3;
         */
        this.status = EMSOrdermadeProductListingApplicationStatus.EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_STATUS_UNSPECIFIED;
        /**
         * @generated from field: string applicant_name = 4;
         */
        this.applicantName = "";
        /**
         * @generated from field: string product_name = 6;
         */
        this.productName = "";
        /**
         * @generated from field: string base_item_name = 7;
         */
        this.baseItemName = "";
        /**
         * @generated from field: string base_item_category = 8;
         */
        this.baseItemCategory = "";
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductVariant variants = 10;
         */
        this.variants = [];
        /**
         * 紐付けタレント (priority 昇順)
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeTalent talents = 11;
         */
        this.talents = [];
        /**
         * 販売価格
         *
         * @generated from field: int32 price = 12;
         */
        this.price = 0;
        /**
         * 事務手数料
         *
         * @generated from field: int32 service_fee = 13;
         */
        this.serviceFee = 0;
        /**
         * 商品原価(SKU(カラー)単位で変動するため範囲で返す。SKUが1つでも min==max として常に両方セット)
         *
         * @generated from field: int32 min_cost = 14;
         */
        this.minCost = 0;
        /**
         * @generated from field: int32 max_cost = 15;
         */
        this.maxCost = 0;
        /**
         * デザイン料(SKU単位で変動するため範囲で返す)
         *
         * @generated from field: int32 min_design_fee = 16;
         */
        this.minDesignFee = 0;
        /**
         * @generated from field: int32 max_design_fee = 17;
         */
        this.maxDesignFee = 0;
        /**
         * トリブン(= 取り分。原価/デザイン料が変動するため範囲で返す)
         *
         * @generated from field: int32 min_toribun = 18;
         */
        this.minToribun = 0;
        /**
         * @generated from field: int32 max_toribun = 19;
         */
        this.maxToribun = 0;
        /**
         * カラー×印刷面ごとの画像 (申請詳細でカラー選択→面別画像表示のソース)
         * 並び順: カラー priority 昇順 → 面 priority 昇順
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductColorSurfaceImage color_surface_images = 22;
         */
        this.colorSurfaceImages = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductListingApplicationDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductListingApplicationDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductListingApplicationDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductListingApplicationDetail, a, b);
    }
}
exports.EMSOrdermadeProductListingApplicationDetail = EMSOrdermadeProductListingApplicationDetail;
EMSOrdermadeProductListingApplicationDetail.runtime = protobuf_1.proto3;
EMSOrdermadeProductListingApplicationDetail.typeName = "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationDetail";
EMSOrdermadeProductListingApplicationDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductListingApplicationStatus) },
    { no: 4, name: "applicant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "submitted_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 6, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "base_item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "base_item_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "variants", kind: "message", T: EMSOrdermadeProductVariant, repeated: true },
    { no: 11, name: "talents", kind: "message", T: EMSOrdermadeTalent, repeated: true },
    { no: 12, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "service_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "min_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "max_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "min_design_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "max_design_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "min_toribun", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "max_toribun", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "closed_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
    { no: 21, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "color_surface_images", kind: "message", T: EMSOrdermadeProductColorSurfaceImage, repeated: true },
]);
/**
 * カラー×印刷面ごとの画像
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductColorSurfaceImage
 */
class EMSOrdermadeProductColorSurfaceImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string color_option_value_id = 1;
         */
        this.colorOptionValueId = "";
        /**
         * @generated from field: string surface_code = 2;
         */
        this.surfaceCode = "";
        /**
         * 「表」「裏」「裾」など、ユーザー向け表示名 (om_factory_print_surface.title)
         *
         * @generated from field: string surface_title = 3;
         */
        this.surfaceTitle = "";
        /**
         * @generated from field: string preview_url = 4;
         */
        this.previewUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductColorSurfaceImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductColorSurfaceImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductColorSurfaceImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductColorSurfaceImage, a, b);
    }
}
exports.EMSOrdermadeProductColorSurfaceImage = EMSOrdermadeProductColorSurfaceImage;
EMSOrdermadeProductColorSurfaceImage.runtime = protobuf_1.proto3;
EMSOrdermadeProductColorSurfaceImage.typeName = "spwn.ordermade.v1.EMSOrdermadeProductColorSurfaceImage";
EMSOrdermadeProductColorSurfaceImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "color_option_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "surface_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "preview_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * OM商品販売申請一覧アイテム
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductListingApplicationListItem
 */
class EMSOrdermadeProductListingApplicationListItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Review API(承認/却下)で対象を指定する際に使用
         *
         * @generated from field: string om_product_id = 2;
         */
        this.omProductId = "";
        /**
         * @generated from field: string product_name = 3;
         */
        this.productName = "";
        /**
         * @generated from field: string brand_name = 4;
         */
        this.brandName = "";
        /**
         * @generated from field: string applicant_name = 5;
         */
        this.applicantName = "";
        /**
         * @generated from field: int32 price = 7;
         */
        this.price = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductListingApplicationListItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductListingApplicationListItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductListingApplicationListItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductListingApplicationListItem, a, b);
    }
}
exports.EMSOrdermadeProductListingApplicationListItem = EMSOrdermadeProductListingApplicationListItem;
EMSOrdermadeProductListingApplicationListItem.runtime = protobuf_1.proto3;
EMSOrdermadeProductListingApplicationListItem.typeName = "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationListItem";
EMSOrdermadeProductListingApplicationListItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "applicant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "submitted_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 7, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "first_image", kind: "message", T: EMSOrdermadeBrandImage, opt: true },
]);
//# sourceMappingURL=ems_common_pb.js.map